import React from 'react';
import {Modal} from 'components/modals';
import {FormattedMessage} from 'react-intl';

const ManagerWelcomeModal = ({frequency, isOpen, onCancel}) => {
  return (
    <Modal isOpen={isOpen} onHide={onCancel} size='md' title='performance.Welcome email to leaders'>
      <div className='border px3 py2 bg-haze rounded'>
        <div className='h4 py1'>
          <FormattedMessage id='performance.MANAGER_PERFORMANCE_WELCOME_MESSAGE' values={{frequency}} />
        </div>
        <div className='h4 py1'>
          <FormattedMessage id='performance.Check-Ins for you to review:'/>
          <ul className='ml3'>
            <li><FormattedMessage id='performance.Employee Name' values={{index: 1}}/></li>
            <li><FormattedMessage id='performance.Employee Name' values={{index: 2}}/></li>
            <li><FormattedMessage id='performance.Employee Name' values={{index: 3}}/></li>
            <li>{'...'}</li>
          </ul>
        </div>
        <div className='h4 py1'>
          <FormattedMessage id='performance.Once received, use this Check-In to guide your one-one-one meetings and then mark as complete. You will also receive reminders when an employee submits a Check-In.'/>
        </div>
      </div>
    </Modal>
  );
};

export default ManagerWelcomeModal;
